export default __webpack_public_path__ + "static/team02-ae54d72cb14ec192ca4ad9420a9deaef.webp";